export const PHONE_CODE_OPTIONS = [
  { label: 'Kenya +254', value: '+254', country: 'Kenya' },
  { label: 'Uganda +256', value: '+256', country: 'Uganda' },
  { label: 'Tanzania +255', value: '+255', country: 'Tanzania' },
  { label: 'Rwanda +250', value: '+250', country: 'Rwanda' },
  { label: 'Burundi +257', value: '+257', country: 'Burundi' },
  { label: 'South Sudan +211', value: '+211', country: 'South Sudan' },
];

export const CURRENCY_OPTIONS = [
  { label: 'Kenyan Shilling (KES)', shortLabel: 'KES', value: 'KES', country: 'Kenya' },
  { label: 'Ugandan Shilling (UGX)', shortLabel: 'UGX', value: 'UGX', country: 'Uganda' },
  { label: 'Tanzanian Shilling (TZS)', shortLabel: 'TZS', value: 'TZS', country: 'Tanzania' },
  { label: 'Rwandan Franc (RWF)', shortLabel: 'RWF', value: 'RWF', country: 'Rwanda' },
  { label: 'Burundian Franc (BIF)', shortLabel: 'BIF', value: 'BIF', country: 'Burundi' },
  { label: 'South Sudanese Pound (SSP)', shortLabel: 'SSP', value: 'SSP', country: 'South Sudan' },
  { label: 'US Dollar (USD)', shortLabel: 'USD', value: 'USD', country: 'International' },
];

export const DEFAULT_PHONE_CODE = '+256';
export const DEFAULT_CURRENCY_CODE = 'UGX';
